module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/frying-pan-3002017a7f07f14c2588c52acf2fc5c0.svg";